module.exports = __webpack_public_path__ + "static/media/Ex3-S0-SectionBreak.a4add008.PNG";